// extracted by css-extract-rspack-plugin
export default {"labelColorIndicator":"ListLabelFilter-module__labelColorIndicator__BIBYJ","labelFilterButton":"ListLabelFilter-module__labelFilterButton__RRvUM"};